import './input.scss';
import React, { ChangeEvent, InputHTMLAttributes, ReactNode } from 'react';
import classNames, { Argument } from 'classnames';
import { Size } from '../../../shared/types/size';

export interface ZenInputTextProps
    extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'prefix' | 'className' | 'onPaste'> {
    size?: Size;
    className?: Argument;
    inputClass?: string;
    rounded?: 'square' | 'circle' | 'round' | Size;
    disabled?: boolean;
    prefix?: ReactNode;
    suffix?: ReactNode;
    noPadding?: boolean;
    value?: string | ReadonlyArray<string> | number | undefined;
    name?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onPaste?: (e: React.ClipboardEvent) => void;
    onBlur?: (e: ChangeEvent) => void;
}

const ZenInputText = React.forwardRef<HTMLInputElement, ZenInputTextProps>(
    (
        // eslint-disable-next-line react/prop-types
        { size, className, inputClass, rounded = 'sm', disabled, prefix, suffix, noPadding = false, value, ...props },
        ref,
    ) => {
        const classList = () => {
            return classNames([
                {
                    [`zen-input-${size}`]: size,
                    [`rounded-4`]: rounded === 'sm',
                    [`rounded-10`]: rounded === 'md',
                    [`rounded-15`]: rounded === 'lg',
                    'bg-grey-light-extra': disabled,
                },
                'zen-input border flex items-center',
                className,
            ]);
        };
        const inputClassList = classNames([
            {
                'px-15': !noPadding && size && ['sm', 'md', 'lg'].includes(size),
            },
            inputClass,
        ]);
        return (
            <div className={classList()}>
                {prefix}
                <input
                    ref={ref}
                    type={`text`}
                    disabled={disabled}
                    autoComplete={`off`}
                    className={inputClassList}
                    value={value !== null ? value : ''}
                    {...props}
                />
                {suffix}
            </div>
        );
    },
);
ZenInputText.displayName = 'ZenInputText';

export default ZenInputText;
